

















import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { Constants } from '@/constants/constants';
import GCompetencyComparison from '@/components/GCompetencyComparison.vue';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';

@Component({
  name: 'GStudentAllCompetencyComparison',
  components: { GCompetencyComparison },
  computed: {},
  methods: {},
})
export default class GStudentAllCompetencyComparison extends Mixins(GPageBase) {
  studentID: number = 0;

  created() {
    this.studentID = parseInt(this.$route.params.studentID);
  }

  mounted() {}

  get competencyIDs(): number[] {
    return Constants.CompetencyIDsBySortedType;
  }
  get sortDiffScore(): StudentCompetencyGrowth[] {
    return studentAllCompetencyModule.sortDiffScore;
  }
}
